module.exports = __webpack_public_path__ + "media/images/base2-75618e3f37823f40fc86d56a367bf7f9.png";